import { filter, flow, get, keyBy, map, mapValues, reverse, sortBy } from 'lodash/fp';

const mapCategories = map(item => ({
  id: item.id,
  abbr: item.abbreviation || item.short_name,
  shortName: item.short_name || item.name,
  name: item.name
}));

function mapAndFilterCategories(categories) {
  const filteredCategories = filter('display', categories);

  if (filteredCategories.length === 0) {
    return mapCategories(categories);
  }

  return mapCategories(sortBy('order', filteredCategories));
}

const mapStats = flow(
  keyBy('id'),
  mapValues('value')
);

const mapGames = flow(
  reverse,
  map(item => ({
    id: item.id,
    awayAbbr: get('away_team.abbreviation', item),
    awayId: get('away_team.id', item),
    awayName: get('away_team.name', item),
    homeAbbr: get('home_team.abbreviation', item),
    homeId: get('home_team.id', item),
    homeName: get('home_team.name', item),
    score: get('score', item),
    startTime: get('start_time', item),
    stats: mapStats(item.stats)
  }))
);

function decodeTeamCompetitionStats(data) {
  return mapValues(fn => fn(data), {
    averageScore: get('competition_team.aggregates.overall.average_score'),
    categories: flow(
      get('stat_types'),
      mapAndFilterCategories
    ),
    competitionId: get('competition_team.competition.id'),
    competitionName: get('competition_team.competition.name'),
    entityId: get('competition_team.team.id'),
    games: flow(
      get('competition_team.games'),
      mapGames
    ),
    highScore: get('competition_team.high_score_game.score'),
    maxScore: get('competition_team.competition.competition_type.max_onescore'),
    name: get('competition_team.team.name'),
    positionAbbr: get('competition_team.position.abbreviation'),
    positionName: get('competition_team.position.name'),
    sportId: get('competition_team.competition.competition_type.sport.id'),
    teamAbbr: get('competition_team.team.abbreviation'),
    teamId: get('competition_team.team.id'),
    teamName: get('competition_team.team.name')
  });
}

export default decodeTeamCompetitionStats;
